<template>
  <footer
    v-bind:class="{ defaultFooter: !footerFixed, fixedFooter: footerFixed }"
  >
    <div class="flex text-center sm:text-left sm:flex-row w-full lg:px-12 mx-4">
      <div class="py-4 hidden sm:flex sm:py-0">© Haus Morgensonne 2026</div>
      <div class="flex sm:flex-row sm:justify-end flex-grow">
        <router-link class="px-2 py-1 mx-2" to="/datenschutz"
          >Datenschutz</router-link
        >
        <router-link class="px-2 py-1 mx-2" to="/impressum"
          >Impressum</router-link
        >
      </div>
    </div>
    <!-- <ul class="flex w-full lg:px-12">
      <li>© Haus Morgensonne 2021</li>
      <span class="flex justify-end flex-grow">
        <li>
          <router-link to="/datenschutz">Datenschutz</router-link>
        </li>
        <li>
          <router-link to="/impressum">Impressum</router-link>
        </li>
      </span>
    </ul> -->
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    footerFixed() {
      return this.$store.state.footerFixed
    },
  },
}
</script>
<style scoped>
li {
  @apply mx-4;
}
li:hover {
  @apply opacity-100 duration-150 ease-in-out transition-opacity;
}

.defaultFooter {
  @apply flex w-full items-center text-base border-t border-gray-200 py-4 mt-24 z-20;
}
.fixedFooter {
  @apply flex w-full fixed bottom-0 text-sm py-4 mt-24 opacity-75 text-white z-20;
}
</style>
